import { render, staticRenderFns } from "./docChat.vue?vue&type=template&id=77398efe&scoped=true"
import script from "./docChat.vue?vue&type=script&lang=js"
export * from "./docChat.vue?vue&type=script&lang=js"
import style0 from "./docChat.vue?vue&type=style&index=0&id=77398efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77398efe",
  null
  
)

export default component.exports